/**
 * @author NikolaV
 */
import { Ajax } from '@shared/Ajax';
import * as React from 'react';


export interface IProjectCode {
    code: string;
    type: string;
    description?: string;
    shortDescription?: string;
}


let projectCodes = {};
let projectCodesJustCodes = [];
let projectCodesJustCodesByType: { [key: string]: string[] } = {};
let isLoaded = false;

function init() {
    if (isLoaded) {
        return;
    }
    Ajax({
        url: '/api/1/project/' + kuura.getProjectId() + '/codes.json',
    }).done(data => {
        isLoaded = true;
        projectCodesJustCodes = Array.from(new Set(data.codes.map(c => c.code)));

        projectCodes = {};
        projectCodesJustCodesByType = {};
        data.codes.forEach((code: IProjectCode) => {
            projectCodes[code.code] = code;

            if (!projectCodesJustCodesByType[code.type]) {
                projectCodesJustCodesByType[code.type] = [];
            }
            projectCodesJustCodesByType[code.type].push(code.code);
        });
    });
}

function get(code: string): IProjectCode {
    return projectCodes[code];
}

function getDescription(code: string): string {
    const codeDef = projectCodes[code];
    return codeDef?.description || codeDef?.shortDescription || null;
}

function codeWithDescription(code): string {
    if (!code) return '';

    const fullCode = get(code);
    if (!fullCode) return code;

    return `${code} (${fullCode.type}) (${fullCode.shortDescription || fullCode.description})`;
}

const ProjectCodeSpan = ({ code }) => <span title={codeTooltip(code)}>{codeWithDescription(code)}</span>;

function codeTooltip(code): string {
    if (!code) return '';

    const fullCode = get(code);
    if (!fullCode) return '';

    return `${kuura.getMessage('tablet.code_js')}: ${code}
${kuura.getMessage('general.type')}: ${fullCode.type}
${kuura.getMessage('general.description')}: ${fullCode.description || fullCode.shortDescription}`;
}

export const ProjectCodesService = {
    init,
    get,
    getDescription,
    codeWithDescription,
    getCodesArray: () => projectCodesJustCodes,
    getCodesArrayByType: (type: string) => projectCodesJustCodesByType[type] || [],
    codeTooltip,
    ProjectCodeSpan
};
